import axios from 'axios';
import axios2 from 'utils/axios';
import { ROUTE_API } from 'configs';
import { dispatch } from 'store';
import { hideTalk, showTalk } from 'store/slices/loadingCursor';
import { objectToQueryString } from 'utils';

export interface TextProp {
    keyword: string[];
    response: string[];
    func?(variable?: any): void;
    type?: 'text' | 'gpt';
}
const Text: TextProp[] = [
    {
        keyword: [
            "good morning"
        ],
        response: [
            "How can I assist you?"
        ],
        func: () => {
            dispatch(showTalk());
        }
    },
    {
        keyword: [
            "stop"
        ],
        response: [
            "Okay"
        ],
        func: () => {
            dispatch(hideTalk());
        }
    },
    {
        keyword: [
            "open facebook"
        ],
        response: [
            "opening your facebook"
        ],
        func: () => {
            window.open("https://www.facebook.com/", "_blank")
        }
    },
    {
        keyword: [
            "open zalo"
        ],
        response: [
            "opening your zalo"
        ],
        func: () => {
            window.open("https://chat.zalo.me/", "_blank")
        }
    },
    {
        keyword: [
            "open youtube"
        ],
        response: [
            "opening youtube"
        ],
        func: () => {
            window.open("https://www.youtube.com/", "_blank")
        }
    },
    {
        keyword: [
            "open skype"
        ],
        response: [
            "opening your skype"
        ],
        func: () => {
            window.open("https://web.skype.com/", "_blank")
        }
    },
    {
        keyword: [
            "what's your name",
            "what is your name"
        ],
        response: [
            "My Name is Kyle"
        ],
        func: () => { }
    },
    {
        keyword: [
            "play a song",
            "play a music",
            "tìm bài hát"
        ],
        response: [
            "OK, Let's me play a song"
        ],
        func: () => {
            window.open("https://www.youtube.com/watch?v=5-EFxE_Ctes&/", "_blank")
        }
    },
    {
        keyword: [
            "new complain",
        ],
        response: [
            "OK, Here is news complain"
        ],
        func: () => {
            window.open("/complaints/new", "_blank")
        }
    },
    {
        keyword: [
            "processing complain",
        ],
        response: [
            "OK, Here is processing complain"
        ],
        func: () => {
            window.open("/complaints/processing", "_blank")
        }
    },
    {
        keyword: [
            "completed complain",
        ],
        response: [
            "OK, Here is completed complain"
        ],
        func: () => {
            window.open("/complaints/completed", "_blank")
        }
    },
    {
        keyword: [
            "closed complain",
        ],
        response: [
            "OK, Here is closed complain"
        ],
        func: () => {
            window.open("/complaints/closed", "_blank")
        }
    },
    {
        keyword: [
            "reopen complain",
        ],
        response: [
            "OK, Here is reopen complain"
        ],
        func: () => {
            window.open("/complaints/reopen", "_blank")
        }
    },
    {
        keyword: [
            "overdue complain",
        ],
        response: [
            "OK, Here is overdue complain"
        ],
        func: () => {
            window.open("/complaints/overdue", "_blank")
        }
    },
    {
        keyword: [
            "all complain",
        ],
        response: [
            "OK, Here is all complain"
        ],
        func: () => {
            window.open("/complaints", "_blank")
        }
    },
    {
        keyword: [
            "report by year",
        ],
        response: [
            "OK, Here is report by year"
        ],
        func: () => {
            window.open("/report/by-year", "_blank")
        }
    },
    {
        keyword: [
            "report by month",
        ],
        response: [
            "OK, Here is report by month"
        ],
        func: () => {
            window.open("/report/by-month", "_blank")
        }
    },
    {
        keyword: [
            "report by stores",
        ],
        response: [
            "OK, Here is report by stores"
        ],
        func: () => {
            window.open("/report/by-stores", "_blank")
        }
    },
    {
        keyword: [
            "report by department",
        ],
        response: [
            "OK, Here is report by department"
        ],
        func: () => {
            window.open("/report/by-department", "_blank")
        }
    },
    {
        keyword: [
            "report by solution",
        ],
        response: [
            "OK, Here is report by solution"
        ],
        func: () => {
            window.open("/report/by-solution", "_blank")
        }
    },
    {
        keyword: [
            "go to dashboard",
        ],
        response: [
            "OK, Here is dashboard for you"
        ],
        func: () => {
            window.open("/dashboard", "_blank")
        }
    },
    {
        keyword: [
            "my profile",
        ],
        response: [
            "OK, Here is your profile"
        ],
        func: () => {
            window.open("/profile-setting", "_blank")
        }
    },
    {
        keyword: [
            "how are you",
        ],
        response: [
            "Yes, I'm good"
        ],
        func: () => { }
    },
    {
        keyword: [
            "listen again",
        ],
        response: [
            "Ok"
        ],
        func: () => { }
    },
    {
        keyword: [
            "that's all",
            "tìm kiếm với google",
        ],
        response: [
            "Ok, Wait 5s seconds"
        ],
        func: (vari: string) => {
            let q: string = convertToURL([
                "that's all",
                "tìm kiếm với google",
            ], vari);
            window.open(`https://www.google.com.vn/search?q=${q}`, "_blank")
        },
        type: "text"
    },
    {
        keyword: [
            "search youtube",
            "tìm kiếm với youtube"
        ],
        response: [
            "Ok, Wait 1s seconds"
        ],
        func: (vari: string) => {
            let q: string = convertToURL([
                "search youtube",
                "tìm kiếm với youtube"
            ], vari);
            window.open(`https://www.youtube.com/results?search_query=${q}`, "_blank")
        },
        type: "text"
    },
    {
        keyword: [
            "trả lời",
        ],
        response: [
            "Ok, Wait 30s seconds"
        ],
        func: async (vari: string): Promise<string> => {
            let result: string = vari.replace("trả lời", "");
            await askGPT(result).then((response: string) =>{
                result = response;
            });
            return result;
        },
        type: "gpt"
    },
    {
        keyword: [
            "ask gemini",
        ],
        response: [
            "Ok, Wait 30s seconds"
        ],
        func: async (vari: string): Promise<string> => {
            let result: string = vari.replace("trả lời", "");
            await askGemini(result).then((response: string) =>{
                result = response;
            });
            return result;
        },
        type: "gpt"
    },
    {
        keyword: [
            "export",
            "ticket",
        ],
        response: [
            "Ok, Wait 30s seconds"
        ],
        func: async (vari: string): Promise<string> => {
            try {
                const params: any = {};
                // searchParams.forEach((value, key) => {
                //     if (key === "page") {
                //         params[key] = `${parseInt(value) + 1}`;
                //     } else {
                //         params[key] = value;
                //     }
                // });
                if (!params?.perpage) {
                    params["perpage"] = 1000;
                }
                await axios2
                    .get(`${ROUTE_API.ticket.export}?${objectToQueryString(params)}`, {
                        headers: { cursorLoading: true },
                        responseType: "blob",
                        timeout: 60000,
                    })
                    .then((response) => {
                        const downloadUrl = `${ROUTE_API.index}/voc_daily_report_filled.xlsx`;
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.target = '_blank'; // Open in a new tab
                        link.download = 'voc_daily_report_filled.xlsx'; // Set download filename
                        link.click();
    
                    });
                    return 'successfully downloaded';
            } catch (error: any) {
                return 'failed to download';
            }
        },
        type: "gpt"
    },

];

const convertToURL = (listText: string[], text: string): string => {
    let q = text.toLowerCase().replace("+","%2B");
    listText.forEach((keyword_search) => {
        q = q.replace(keyword_search, "");
    });
    // convert spaces to + and remove last +
    q = q.replace(/ /g, '+').replace(/(.*)\+$/, '$1');
    return q;
}
export const askGPT = async (message: string): Promise<string> => {
    const dataSend = {
        model: 'gpt-3.5-turbo-0301',
        messages: [{ role: 'user', content: message }]
    };
    try {
        let result = "Something went wrong";
        const url = 'https://api.openai.com/v1/chat/completions'
        const headers = {
            'Content-type': 'application/json',
            Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`
        }

        await axios.post(url, dataSend, { headers: headers }).then((response) => {
            let text: string = response.data.choices[0].message.content ?? "";
            text = text.replace(/\n/g, "<br />");
            if (text) {
                result = text;
            }
        });
        return result;
    } catch (error) {
        return "Something went wrong"
    }
}

const askGemini = async (message: string) => {
    const url = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=AIzaSyBZzQxLge5TaJEfaMl4iEpbAMErSzQmHyA';
    const dataSend = {
        contents: [{ parts: [{ text: message }] }]
    };
    const headers = {
        'Content-Type': 'application/json',
        // Authorization: `Bearer ${process.env.REACT_APP_GEMINI_API_KEY}`
    };
    const response = await axios.post(url, dataSend, { headers });
    let text: string = response.data.candidates?.[0]?.content?.parts?.[0]?.text ?? "";
    text = text.replace(/\n/g, "<br />");
    let result = "Something went wrong";
    if (text) {
        result = text;
    }
    return result;
}
export default Text;